<template>
    <multiselect
            :clear-on-select="false"
            :close-on-select="true"
            :hide-selected="true"
            :internal-search="false"
            :limit="3"
            :loading="isLoading"
            :max-height="600"
            :options="services"
            :options-limit="300"
            :searchable="true"
            :show-no-results="false"
            @search-change="getGoodsServices"
            @input="onSelect()"
            data-vv-as="goodsservice"
            id="goodsservice"
            label="goodsservice"
            name="goodsservice"
            open-direction="bottom"
            placeholder="Search Goods/Service"
            selectLabel=""
            track-by="id"
            v-model="selectedGS"
            v-validate="'required'">
        <template slot="singleLabel" slot-scope="props">
            <div class="option__desc">
                <div class="option__desc" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                    {{ props.option.name }} - {{ props.option.variety }}
                </div>
            </div>
        </template>
        <template slot="option" slot-scope="props">
            <div class="option__desc">
                <div class="option__desc" v-if="props.option">
                    <h5>{{ props.option.name }}</h5>
                    {{ props.option.variety }}
                </div>
                <div class="option__desc" v-else>
                    <h5>Add New</h5>
                </div>
            </div>
        </template>
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import _ from 'lodash';

    export default {
        name: "GoodServicesSelect",
        props: {
            searchType: String,
            expressid: {
                type: Number
            },
            width: {
                type: Number,
                default: 32
            },
            goodsSerivces: Object
        },
        components: {Multiselect},
        data() {
            return {
                isLoading: false,
                selectedGS: null,
                services: []
            }
        },
        mounted() {
            if(this.goodsSerivces){
                this.selectedGS = this.goodsSerivces;
            }
        },
        watch: {
            goodsSerivces: function(nv,ov) {
                this.selectedGS = this.goodsSerivces;
            }
        },
        methods: {
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply      = await this.$http.get("/express/" + this.expressid + "/goodsservices/search", {
                    params: {
                        search: searchText,
                        excludeOld: true
                    }
                });
                if(this.searchType === 'PURCHASE'){
                    this.services  = _.filter(reply.data, {'type': 'PURCHASE'});
                } else if(this.searchType === 'SALE'){
                    this.services  = _.filter(reply.data, {'type': 'SALE'});
                } else{
                    this.services  = reply.data;
                }
                this.isLoading = false;
            },
            onSelect() {
                this.$emit('good-services-select', this.selectedGS);
            }
        }
    }
</script>

<style scoped>

</style>
